import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { DashboardProvider } from './context/dashboard-context';
import { DashboardComponent } from './dashboard-component';

export function DashboardFactory() {
    return (
        <BaseLayoutFactory>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DashboardProvider>
                    <DashboardComponent />
                </DashboardProvider>
            </LocalizationProvider>
        </BaseLayoutFactory>
    );
}
